import SDRLeadInbox from './SDRLeadInbox';

export default SDRLeadInbox;
